export type DataPackageGroupOption = {
  id: number;
  name: string;
  arenaId?: number | null;
};

export type DataPackageSection<T extends DataPackageGroupOption = DataPackageGroupOption> = {
  key: "system" | "arena";
  name: string;
  packages: T[];
};

export const buildDataPackageSections = <T extends DataPackageGroupOption>(
  dataPackages: T[],
  arenaName?: string,
): DataPackageSection<T>[] => {
  const systemPackages = dataPackages.filter((pkg) => pkg.arenaId == null);
  const arenaPackages = dataPackages.filter((pkg) => pkg.arenaId != null);
  const safeArenaName = arenaName?.trim() || "Arena";
  const arenaGroupName = safeArenaName.toUpperCase();
  const sections: DataPackageSection<T>[] = [];

  if (systemPackages.length > 0) {
    sections.push({ key: "system", name: "SYSTEM", packages: systemPackages });
  }

  if (arenaPackages.length > 0) {
    sections.push({ key: "arena", name: arenaGroupName, packages: arenaPackages });
  }

  return sections;
};
